var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarksThread(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 22.5C15.5962 22.4999 15.4462 22.4525 15.3203 22.3643L8.25 17.4158L1.17975 22.3657C1.06727 22.4444 0.935355 22.4907 0.798388 22.4995C0.661422 22.5084 0.524651 22.4795 0.402975 22.416C0.281298 22.3525 0.179382 22.2568 0.108327 22.1394C0.0372715 22.0219 -0.000197596 21.8873 7.83665e-07 21.75V3.6C0.000993478 2.64553 0.380597 1.73043 1.05551 1.05551C1.73043 0.380596 2.64553 0.000992694 3.6 0H12.9C13.8545 0.000992694 14.7696 0.380596 15.4445 1.05551C16.1194 1.73043 16.499 2.64553 16.5 3.6V21.75C16.5 21.9489 16.421 22.1397 16.2803 22.2803C16.1397 22.421 15.9489 22.5 15.75 22.5ZM8.25 15.75C8.40378 15.7501 8.55381 15.7975 8.67975 15.8857L15 20.3092V3.6C15 3.04305 14.7788 2.5089 14.3849 2.11508C13.9911 1.72125 13.457 1.5 12.9 1.5H3.6C3.04305 1.5 2.5089 1.72125 2.11508 2.11508C1.72125 2.5089 1.5 3.04305 1.5 3.6V20.3092L7.82025 15.8843C7.94637 15.7965 8.09639 15.7497 8.25 15.75Z",
    fill: "#71B8CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarksThread);
export default __webpack_public_path__ + "static/media/bookmarks-thread.6175332318a00a1807e342c2de26f2e0.svg";
export { ForwardRef as ReactComponent };